import type { IntakeRecord } from '../../../types/data';

export const intakeRecordHeaders = [
  'name',
  'dosage_taken',
  'dosage_units',
  'intake_time'
] as const;

export const toCSV = (record: IntakeRecord): Record<string, string> => ({
  name: record.name,
  dosage_taken: record.dosage_taken?.toString() || '',
  dosage_units: record.dosage_units || '',
  intake_time: record.intake_time || new Date().toISOString()
});

export const fromCSV = (row: Record<string, string>): Partial<IntakeRecord> => ({
  name: row.name,
  dosage_taken: row.dosage_taken ? Number(row.dosage_taken) : undefined,
  dosage_units: row.dosage_units,
  intake_time: row.intake_time || new Date().toISOString()
});